
        import { authManager } from '/src/auth.ts';

        async function initApp() {
            const loginScreen = document.getElementById('loginScreen');
            const loginButton = document.getElementById('loginButton');
            const playerContainer = document.querySelector('.player-container');

            // Set up login button handler
            loginButton.addEventListener('click', async () => {
                await authManager.login();
            });

            // Check authentication
            const isAuthenticated = await authManager.initialize();

            if (isAuthenticated) {
                // Hide login screen and show app
                console.log('[App] Auth successful, loading main application');
                loginScreen.style.display = 'none';
                playerContainer.style.display = 'block';

                // Load main.ts
                import('/src/main.ts').then(() => {
                    console.log('[App] main.ts loaded successfully');
                }).catch(err => {
                    console.error('[App] Failed to load main.ts:', err);
                });
            } else {
                // Show login screen, hide player
                console.log('[App] Not authenticated, showing login screen');
                loginScreen.style.display = 'block';
                playerContainer.style.display = 'none';
            }
        }

        initApp();
    